export const CLOSED_CAPTIONS_STORAGE_KEY = 'CLOSED_CAPTIONS_STORAGE_KEY';
export const VIDEO_RESOLUTION_STORAGE_KEY = 'VIDEO_RESOLUTION_STORAGE_KEY';
